function GetCookieDomain () {
  var host = location.hostname
  var ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
  if (ip.test(host) === true || host === 'localhost') return host
  var regex = /([^]*).*/
  var match = host.match(regex)
  if (typeof match !== 'undefined' && match !== null) host = match[1]
  if (typeof host !== 'undefined' && host !== null) {
    var strAry = host.split('.')
    if (strAry.length > 1) {
      host = strAry[strAry.length - 2] + '.' + strAry[strAry.length - 1]
    }
  }
  return '.' + host
}

var suffix = GetCookieDomain()

export const cookie = {
  set: function (key, val, time) { // 设置cookie方法
    var date = new Date() // 获取当前时间
    var expiresDays = time // 将date设置为n天以后的时间
    date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000) // 格式化为cookie识别的时间
    document.cookie = key + '=' + val + ';expires=' + date.toGMTString() + ';path=/;domain=' + suffix // 设置cookie
  },
  setTwo: function (key, val) { // 设置cookie方法
    var curDate = new Date()
    // 当前时间戳
    var curTamp = curDate.getTime()
    // 当前日期
    var curDay = curDate.toLocaleDateString()
    var curWeeHours = 0
    curWeeHours = new Date(curDay).getTime() - 1
    // 当日已经过去的时间（毫秒）
    var passedTamp = curTamp - curWeeHours
    // 当日剩余时间
    var leftTamp = 24 * 60 * 60 * 1000 - passedTamp
    var leftTime = new Date()
    leftTime.setTime(leftTamp + curTamp)
    // 创建cookie
    document.cookie = key + '=' + val + ';expires=' + leftTime.toGMTString() + ';path=/;domain=' + suffix // 设置cookie
  },
  get: function (key) { // 获取cookie方法
    /* 获取cookie参数 */
    var getCookie = document.cookie.replace(/[ ]/g, '') // 获取cookie，并且将获得的cookie格式化，去掉空格字符
    var arrCookie = getCookie.split(';') // 将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
    var tips // 声明变量tips
    for (var i = 0; i < arrCookie.length; i++) { // 使用for循环查找cookie中的tips变量
      var arr = arrCookie[i].split('=') // 将单条cookie用"等号"为标识，将单条cookie保存为arr数组
      if (key === arr[0]) { // 匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
        tips = arr[1] // 将cookie的值赋给变量tips
        break // 终止for循环遍历
      }
    }
    return tips
  },
  delete: function (key) { // 删除cookie方法
    var date = new Date() // 获取当前时间
    date.setTime(date.getTime() - 10000) // 将date设置为过去的时间
    document.cookie = key + '=v; expires =' + date.toGMTString() + ';path=/;domain=' + suffix // 设置cookie
  }
}

export default cookie
